const prefix = 'rest/api/V1';
const languagePrefix = window.languagePrefix ?? '';

export const endpoints = {
  travel: {
    GET_PRICE: `${prefix}/praemie/reise/`,
    SEPA: `${prefix}/bestellung/reise/sepa/`,
    HOBEX_PAYMENT: `${prefix}/bestellung/reise/hobex/`,
    HOBEX_ORDER: `${prefix}/bezahlung/reise/hobex/`,
    DOWNLOAD_DOCS: `${prefix}/dokument/{bestellId}/download/{typ}/`
  },
  bike: {
    GET_PRICE: `${prefix}/praemie/fahrrad/`,
    SEPA: `${prefix}/bestellung/fahrrad/sepa/`,
    PAYMENT_SLIP: `${prefix}/bestellung/fahrrad/erlagschein/`
  },
  prom: {
    GET_PRICE: `${prefix}/praemie/maturaball/`,
    SEPA: `${prefix}/bestellung/maturaball/sepa/`,
    PAYMENT_SLIP: `${prefix}/bestellung/maturaball/erlagschein/`
  },
  expertInterpreter: {
    GET_PRICE: `rest/api/V1/praemie/sachverstaendige/`,
    GET_GROUPS: `rest/api/V1/enum/fachgruppen/`,
    SEPA: `rest/api/V1/bestellung/sachverstaendige/sepa/`,
    PAYMENT_SLIP: `rest/api/V1/bestellung/sachverstaendige/erlagschein/`
  },
  paymentFormMk: {
    SEPA: `${prefix}/bestellung/folgepraemie/sepa/`,
    HOBEX_ORDER: `${prefix}/bestellung/folgepraemie/hobex/`,
    HOBEX_PAYMENT: `${prefix}/bezahlung/folgepraemie/hobex/`
  },
  paymentFormHu: {
    GPWEBPAY_ORDER: `${prefix}/api/v1/gpwebpay/placeOrder`
  },
  lifeInsuranceFormMkd: {
    CPAY_ORDER: `${prefix}/api/v1/cpay/placeOrder/`,
    GET_POLICY_PAYMENT: `${prefix}/api/v1/cpay/getPolicyPayment/`,
    GET_OFFER_PAYMENT: `${prefix}/api/v1/cpay/getOfferPayment/`
  },
  locations: {
    OFFICES: `${languagePrefix}/?type=500`,
    ADVISORS: `${languagePrefix}/?type=510`,
    REGISTRATION_OFFICES: `${languagePrefix}/?type=520`,
    REGIONS: `${languagePrefix}/?type=530`,
    REGIONS_DISTINCT: `${languagePrefix}/?type=540`,
    LANGUAGES: `${languagePrefix}/?type=550`
  },
  STORNO: `${prefix}/bezahlung/storno/hobex/`,
  DOCUMENT_BASE: `${prefix}/dokument`
};
export default endpoints;
